module.exports = __webpack_public_path__ + "static/media/RU.1c05b64b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/RU.svg
// module id = 349
// module chunks = 0